<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="系统账户" width="25%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="accountInfo" ref="accountForm" :rules="rules" size="small">
          <el-form-item label="昵称" :inline="true" class="znk_form_item" prop="nickName">
            <el-input v-model="accountInfo.nickName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户名" :inline="true" class="znk_form_item" prop="userName">
            <el-input v-model="accountInfo.userName" :disabled="accountInfo.disabledUserName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :inline="true" class="znk_form_item" prop="phone">
            <el-input v-model="accountInfo.phone" :disabled="accountInfo.disabledPhone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" :inline="true" v-if="accountInfo.showPasseord" class="znk_form_item" prop="password">
            <el-input v-model="accountInfo.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" :inline="true" class="znk_form_item" prop="email">
            <el-input v-model="accountInfo.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="saveAccountFunc()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { getInfo,storeAccountInfo } from "@/cookie";
import { Message,MessageBox } from 'element-ui';
import { editorAccount,saveSystemAccount } from "@/api/account";

export default {
  name: "EditSystemAccountDialog",
  props: {
      dialogVisible: false,
      accountInfo : {
        id: '',
        email : '',
        phone:'',
        userName:'',
        nickName:'',
        showPasseord:true,
        disabledUserName:false,
        disabledPhone: false,
      },
  },
  data(){
    return {
      rules: {
          nickName: [
            { required: true, message: "请输入昵称", trigger: "blur" },
          ],
          userName: [
            { required: true, message: "请输入账户名", trigger: "blur" },
          ],
          phone: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
          ],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
          ],
      },
      loading:false,
    }
  },
  mounted(){
     
  },
  created() {

  },
  watch : {
    
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('closeAccountDialog');
    },

    //保存用户信息
    saveAccountFunc(){
      let this_ = this;
      let param = {...this_.accountInfo}
      this_.loading = true;
      saveSystemAccount(param).then(res => {
          this_.loading = false;
          if(res.code == 200){
              Message.success('保存成功'); 
              this_.$emit('closeAccountDialog');
          } else {
              Message.error(res.msg);
          }
      });
    },

    
  },
};
</script>

<style>
.znk_form_item {
  margin-bottom: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/EditSystemAccountDialog.vue